import {INIT_RESULT_MSG} from '@app/const/AppSetting';

export const calculateWindowSize = (windowWidth) => {
    if (windowWidth >= 1200) {
        return 'lg';
    }
    if (windowWidth >= 992) {
        return 'md';
    }
    if (windowWidth >= 768) {
        return 'sm';
    }
    return 'xs';
};
export const getSaveResult = (_func) => {
    const val = _func
        .then((responde) => {
            const dataX = responde.data;
            if (dataX) {
                return dataX;
            }
            return INIT_RESULT_MSG;
        })
        .catch((error) => {
            //console.log(
                //'helpers.getSaveResult.Exception',
                //JSON.stringify(error, null, 2)
            //);
            return {...INIT_RESULT_MSG, msg: `Exception:${error.message}`};
        });
    return val;
};
export const getControllerName = (fullpath) => {
    const parts = fullpath.split('/');
    if (parts.length > 1) return parts[1];
    return ``;
};

export const getControllerName_v2 = (fullpath, num) => {
    const parts = fullpath.split('/');
    if (parts.length > num) return parts[num];
    return ``;
};

export const getDefaultSelectValue = (options, value) => {
    if(!value && value !== 0)
        return '';
    return options
        ? options.find((option) => option.value + '' === value + '')
        : '';
};

export const renewTrangthai  = async (trangthaiSelector,mainService,dispatch) => {
   
    if(trangthaiSelector && trangthaiSelector.length > 0 )
    {
        return trangthaiSelector;
    }
    else
    {
        const tt=  await mainService.getAllTrangthai(dispatch);
        return tt;
    }
};

export const renewCoquan  = async (coquanSelector,mainService,dispatch) => {

    if(coquanSelector && coquanSelector.length > 0 )
    {
        return coquanSelector;
    }
    else
    {
        const tt=  await mainService.getAllCoquan(dispatch);
        return tt;
    }
};